import React from 'react';
import Filters from '../../components/Filters';
import { Form } from 'react-bootstrap';
import MultiSelectField from '../../components/form/MultiSelectField';
import { faInfoCircle, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FiltersPartial = (props) => {
  const { filtersModel, setFiltersModel } = props;

  const onBranchSelect = (selectedItems, selectedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, branch_ids: [...(prevState?.branch_ids || []), selectedOption.id] }
    })
  }

  const onBranchRemove = (selectedItems, removedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, branch_ids: prevState.branch_ids.filter((id) => id !== removedOption.id), offer_ids: [] }
    })
  }

  const onOfferSelect = (selectedItems, selectedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, offer_ids: [...(prevState?.offer_ids || []), selectedOption.id] }
    })
  }
  const onOfferRemove = (selectedItems, removedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, offer_ids: prevState.offer_ids.filter((id) => id !== removedOption.id) }
    })
  }

  const onLeaseTypeChange = (e) => {
    setFiltersModel((prevState) => {
      if (e.target.value === "") {
        let s = { ...prevState }
        delete s.lease_type
        return s;
      } else {
        return { ...prevState, lease_type: e.target.value }
      }
    })
  }

  const onStatusAdded = (selectedItems, selectedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, status: [...(prevState?.status || []), selectedOption.id] }
    })
  }

  const onStatusRemove = (selectedItems, removedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, status: prevState.status.filter((id) => id !== removedOption.id) }
    })
  }

  return <Filters filtersModel={filtersModel} setFiltersModel={setFiltersModel}>
    <div>
      <Form.Group className="mb-3">
        <Form.Label>Status</Form.Label>
        <MultiSelectField
          options={[
            {
              id: 'draft',
              name: 'Draft'
            },
            {
              id: 'submitted',
              name: 'Submitted'
            },
            {
              id: 'pending',
              name: 'Pending'
            },
            {
              id: 'accepted',
              name: 'Approved'
            },
            {
              id: 'rejected',
              name: 'Rejected'
            },
            {
              id: 'partially_accepted',
              name: 'Partially Approved'
            },
            {
              id: 'cancelled_registration',
              name: 'Cancelled Registration'
            }
          ]}
          fieldName="status"
          stateModel={filtersModel}
          labelAttr="name"
          valueAttr="id"
          displayValue="name"
          onSelect={onStatusAdded}
          onRemove={onStatusRemove}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Circle</Form.Label>
        <MultiSelectField
          options={[]}
          fieldName="branch_ids"
          stateModel={filtersModel}
          dynamicOptions={{
            dependsOnFields: [],
            apiName: "branches",
            dataAttr: "branches",
          }}
          labelAttr="name"
          valueAttr="id"
          displayValue="name"
          onSelect={onBranchSelect}
          onRemove={onBranchRemove}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Offer</Form.Label>
        <OverlayTrigger
          placement="top"
          delay={{ show: 250, hide: 400 }}
          overlay={(props) =>
            <Tooltip id="search-ifo-tooltip" {...props} style={{ ...props.style, fontSize: "11px" }}>
              Please Select Circle to select offers
            </Tooltip>}
        >
          <FontAwesomeIcon
            className="icon ms-2"
            icon={faInfoCircle}
            style={{ cursor: 'pointer', color: 'red' }}
          />
        </OverlayTrigger>
        <MultiSelectField
          options={[]}
          fieldName="offer_ids"
          stateModel={filtersModel}
          dynamicOptions={{
            dependsOnFields: ["branch_ids"],
            apiName: "offers",
            dataAttr: "offers",
          }}
          labelAttr="name"
          valueAttr="id"
          displayValue="name"
          onSelect={onOfferSelect}
          onRemove={onOfferRemove}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>
          Lease Type
        </Form.Label>
        <select
          className="form-control form-control-sm font-size-12"
          value={filtersModel?.lease_type}
          onChange={onLeaseTypeChange}
        >
          <option value="">Non-Lease</option>
          <option value="online">Online</option>
          <option value="offline">Offline</option>
        </select>
      </Form.Group>
    </div>
  </Filters>
};

export default FiltersPartial;

